var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M10.4 16l14.3 14.3-1.4 1.4L7.6 16 23.3.3l1.4 1.4"})));
}

ChevronLeft.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
